export const dossierStrings = {
  dossier: {
    id: 'ID',
    noticed: 'Gesehen',
    priority: 'Priorität',
    substatus: 'Substatus',
    description: 'Beschreibung',
    name: 'Name',
    begin: 'Beginn',
    additionalDate: 'Datum Sonstiges',
    additionalDatePlaceholder: 'Erstellen Sie ein Datum',
    referenceFile: 'Aktenzeichen',
    referenceFilePlaceholder: 'Aktenzeichen',
    groupProcesses: 'Gruppenvorgänge',
    groupProcessesEmpty: 'Keine zugeordneten Gruppenvorgänge vorhanden',
    requestTypeLegalBase: 'Rechtsgrundlage',
    requestTypeAdditionalFeatures: 'Weitere Merkmale',
    assignee: 'Federführer',
    assigneeEditor: 'Zuständiger Bearbeiter',
    modified: 'Geändert',
    businessKey: 'Geschäftszeichen',
    assigneeGroupWithRole: 'Federführer (Gruppe)',
    assigneeWithRole: 'Federführer (Bearbeiter)',
    responsibleAssignee: 'Zuständiger Sachbearbeiter',
    subject: 'Betreff',
    requestNumber: 'Antragsnummer',
    initialRequestNumber: 'Antragnummer Bundesportal',
    applicant: 'Antragsteller',
    approvalHolder: 'Genehmigungsinhaber',
    requestDate: 'Antragstellung',
    recipient: 'Empfänger',
    endUser: 'Endverwender',
    sender: 'Absender',
    acquirer: 'Erwerber',
    transferor: 'Überlasser',
    broker: 'Handels-/Vermittlungspartner',
    goods: 'Waren',
    goodsList: 'Güterliste',
    goodsWorth: 'Warenwert',
    goodsDesignation: 'Warenbezeichnung',
    finalFee: 'Finale Gebühr',
    goodsUsage: 'Warenverwendung',
    goodsWorthWeapons: 'Gesamtwert aller Kriegswaffen',
    approvalFacts: 'Genehmigungsstatbestand',
    specialPermissions: 'Sondergenehmigung',
    importExportTypes: 'Ein- oder Ausfuhrart',
    otherRequest: 'Sonstige Anfrage',
    completedDate: 'Bescheidungsdatum',
    approvedTerm: 'Genehmigte Laufzeit',
    closureType: 'Abschlussart',
    approval: 'Genehmigung',
    status: 'Status',
    changed: 'Geändert',
    changedBy: 'Geändert von',
    regards: 'Betrifft',
    logbook: 'Logbuch',
    assignmentDate: 'Eingang',
    submissionDate: 'Ressortvorlage',
    requestedTerm: 'Beantragte Laufzeit',
    viaCountries: 'Über',
    countryGroup: 'Länderkreis',
    thirdCountry: 'Drittstaat',
    destinationCountries: 'Endbestimmungsländer',
    dossierType: 'Vorgangsart',
    additionalDossierType: 'Beförderung zur Herstellung',
    exhibitions: 'Messen',
    businessTypesNotes: 'Bemerkungen (Auslandsgeschäfte)',
    businessTypes: 'Art des Geschäfts',
    additionalRequestDetails: 'Zusätzliche Antragsdetails',
    additionalRequestDetailsKwg:
      'Weitere für den Antrag relevante Angaben des Antragstellers',
    additionalProcessingDetails: 'Zusätzliche Bearbeitungsdetails',
    priorApprovals: 'Vorgenehmigungen',
    requestDetailNotes: 'Bemerkungen (Antragsdetails)',
    priorRequests: 'Angaben zu Voranfragen',
    additionalMigrationInformation: 'Restinformation aus der Migration',
    parties: 'Beteiligte',
    fileNumber: 'Geschäftszeichen',
    notes: 'Notizen',
    resubmissionDueDate: 'Frist Wiedervorlage',
    votes: 'Votes',
    requestType: 'Antragsart',
    counter: 'GZ-Zähler',
    responsibility: 'Zuständigkeit',
    countryCode: 'Länderkürzel',
    decisionLevel: 'Entscheidungsebene',
    administrativeSubmission: 'Leitungsvorlage',
    administrativeSubmissionDate: 'Datum',
    approvalNote: 'Bemerkung',
    checkProgram: 'Prüfprogramm',
    approvalCopiesTo: 'Zusätzliche Kopien an',
    componentClause: 'Bestandteilsklausel',
    collateralClause: 'Nebenbestimmung',
    collateralClauseContent: 'Inhalt',
    initialApprovalDate: 'Ursprüngliche Genehmigung vom',
    approvalChangedFor: 'Genehmigung geändert bezüglich',
    feeExemption: 'Gebührenbefreiung',
    feeTanNumber: 'Kassenzeichen',
    feeFact: 'Gebührentatbestände',
    feeNotes:
      'Erläuterung, warum in diesem Einzelfall von der Regelgebühr abgewichen wird',
    feeDiscount: 'Ermäßigung',
    approvalStartDate: 'Genehmigung Beginn',
    approvalEndDate: 'Genehmigung Ende',
    approvalNumber: 'Genehmigungsnummer',
    destinationCountry: 'Endbestimmungsland',
    documents: 'Dokumente',
    messages: 'E-Mail-Nachrichten',
    similarDossiers: 'Ähnliche Vorgänge',
    identifierType: 'Art der Kennung',
    identifierName: 'Kennung',
    identifierAddendum: 'Zusatz',
    writeRestrictedToLead: 'Schreibrechte nur für Federführer',
    readRestrictedToGroup: 'Leserechte nur für Nutzergruppe',
  },
  entitySingular: 'Einzelvorgang',
  entityPlural: 'Einzelvorgänge',
  search: {
    number: 'Schnelle Suche',
    numberHint: 'Vorgangsnummer, Geschäftszeichen (Anfang)',
    numberPlaceholder: 'Vorgangsnummer oder Geschäftszeichen...',
    extended: 'Langsame Suche',
    extendedHint:
      'alle Vorgangsinhalte inkl. Beteiligte, Listenposition, Beschreibung, Notizen',
    extendedPlaceholder: 'Suche in allen Vorgangsinhalten...',
    scopeLabel: 'Suchumfang',
  },
  listName: {
    all: 'Alle Einzelvorgänge',
    my: 'Meine Einzelvorgänge',
    our: 'Unsere Einzelvorgänge',
    management: 'Referatsleitung',
  },
  messages: {
    load: {
      error: 'Vorgang konnte nicht geladen werden',
    },
    deletion: {
      success: (name: string) => `Vorgang "${name}" wurde erfolgreich gelöscht`,
      error: 'Vorgang konnte nicht gelöscht werden',
      confirm: (name: string) =>
        `Möchten Sie den Vorgang "${name}" endgültig löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.`,
    },
    update: {
      success: 'Vorgang erfolgreich aktualisiert',
      error:
        'Beim Speichern des Vorgangs ist ein Fehler aufgetreten! Bitte prüfen Sie Ihre Angaben.',
      failed: 'Die Änderungen am Vorgang konnten nicht gespeichert werden.',
    },
    create: {
      success: 'Vorgang erfolgreich erstellt',
      error:
        'Beim Speichern des Vorgangs ist ein Fehler aufgetreten! Bitte prüfen Sie Ihre Angaben.',
      failed: 'Der Vorgang konnte nicht angelegt werden.',
      draftFailed:
        'Der Vorgangsentwurf konnte nicht angelegt werden. Ihre Eingaben sind noch nicht gespeichert.',
    },
    resubmission: {
      scheduleFailed:
        'Die Erinnerungsmail zur Wiedervorlage konnte nicht eingeplant werden.',
      recipientsRequired:
        'Für die Wiedervorlage ist mindestens ein Empfänger erforderlich.',
    },
    clone: {
      success: (name: string) =>
        `Vorgang "${name}" wurde erfolgreich dupliziert`,
      error: 'Vorgang konnte nicht dupliziert werden',
    },
    export: {
      error: 'Die Liste konnte nicht exportiert werden',
    },
    other: {
      createInitialParty: 'Erstellen Sie einen Beteiligten',
      createInitialTransportation: 'Erstellen Sie eine Beförderung',
      createInitialGood: 'Erstellen Sie eine Ware',
      createInitialVote: 'Erstellen Sie ein Votum',
      createInitialClause: 'Erstellen Sie eine Nebenbestimmung',
      noSimilarDossiers:
        'Es wurden keine weiteren Vorgänge mit der ursprünglichen Antragsnummer des Vorgangs gefunden.',
    },
    nestedEntities: {
      error:
        'Beim Speichern des Vorgangs ist ein Fehler aufgetreten! Bitte prüfen Sie Ihre Angaben.',
      intro:
        'Der Vorgang wurde gespeichert, aber folgende Angaben konnten nicht übernommen werden:',
      more: (count: number) => `... und ${count} weitere`,
      sections: {
        parties: 'Beteiligte',
        goods: 'Waren',
        votes: 'Voten',
        additionalFeatures: 'Weitere Merkmale',
        legalBase: 'Rechtsgrundlagen',
        keywords: 'Schlüsselwörter',
      },
    },
    invalidFields: {
      intro: 'Bitte prüfen Sie folgende Felder:',
    },
    archivedValues: (names: string[]) =>
      [
        'Folgende Werte sind archiviert und müssen ersetzt werden:',
        ...names.map((name) => `- ${name}`),
      ].join('\n'),
    log: {
      error: 'Der Logbucheintrag konnte nicht gespeichert werden.',
    },
    takeLeadership: {
      success: 'Federführung erfolgreich übernommen',
      error: 'Federführung konnte nicht übernommen werden',
    },
    transferLeadership: {
      success: 'Federführung erfolgreich übertragen',
      error: 'Federführung konnte nicht übertragen werden',
      notifyCurrentAssignee: 'Aktuellen Federführer benachrichtigen',
      notifyNewAssignee: 'Neuen Federführer benachrichtigen',
    },
    mailSplit: {
      header: 'Anhänge zu groß für eine E-Mail',
      description:
        'Die ausgewählten Anhänge sind zusammen {0} groß. Der Mailserver lässt nur {1} pro E-Mail zu, daher wird der Versand auf {2} E-Mails aufgeteilt.',
      hint: 'Die E-Mails tragen den Zusatz "Teil 1 von {0}" im Betreff und gehen nacheinander an dieselben Empfänger.',
      confirm: 'In {0} E-Mails versenden',
      oversizedHeader: 'Anhang zu groß',
      oversizedDescription:
        'Folgende Anhänge sind für sich genommen größer als die pro E-Mail zulässigen {0} und können nicht versendet werden. Bitte entfernen Sie sie aus der Auswahl:',
    },
    archive: {
      success: 'Vorgang erfolgreich veraktet',
      successSplit:
        'Vorgang veraktet - die Anhänge wurden auf {0} E-Mails verteilt',
      error: 'Vorgang konnte nicht veraktet werden',
      confirm: 'Möchten Sie den Vorgang "{0}" verakten?',
      selectDocuments: 'Dokumente für die Veraktungs-E-Mail auswählen',
      selectMessages: 'E-Mails (.eml) für die Veraktungs-E-Mail auswählen',
      selectCoSignatures:
        'Mitzeichnungen (.eml) für die Veraktungs-E-Mail auswählen',
      selectedItemsLabel: '{0} Elemente ausgewählt',
    },
    close: {
      success: 'Vorgang erfolgreich abgeschlossen',
      error: 'Vorgang konnte nicht abgeschlossen werden',
      confirm: 'Möchten Sie den Vorgang "{0}" abschließen?',
    },
    resume: {
      success: 'Vorgang erfolgreich wiederaufgenommen',
      error: 'Vorgang konnte nicht wiederaufgenommen werden',
      confirm: 'Möchten Sie den Vorgang "{0}" wiederaufnehmen?',
    },
    assignTan: {
      success: 'Kassenzeichen erfolgreich zugewiesen',
      error: 'Kassenzeichen konnte nicht zugewiesen werden',
      noneAvailable: 'Es ist kein freies Kassenzeichen verfügbar',
    },
  },
  dialogs: {
    confirmSubstatus: {
      message:
        'Bitte überprüfen Sie den gewählten Substatus. Sie können ihn bei Bedarf vor dem Speichern ändern oder das Speichern abbrechen.',
      header: 'Substatus überprüfen',
      unfilledPlaceholders: (count: number) =>
        count === 1
          ? 'Im Logbucheintrag ist 1 Vorlagenfeld nicht ausgefüllt. Es wird als [Name] gespeichert.'
          : `Im Logbucheintrag sind ${count} Vorlagenfelder nicht ausgefüllt. Sie werden als [Name] gespeichert.`,
    },
    generationValidation: {
      headerFeeBill: 'Gebührenbescheid generieren',
      headerApproval: 'Genehmigungsbescheid generieren',
      description:
        'Bitte prüfen Sie die folgenden Voraussetzungen. Sie können das Dokument trotzdem generieren, falls dies notwendig ist.',
      navigateToTab: (tab: string) => `Zum Tab „${tab}" wechseln`,
    },
  },
  detail: {
    title: 'Vorgang',
    sections: {
      meta: 'Stammdaten',
      goods: 'Ware',
      goodItems: 'Ware im Einzelnen',
      logbook: 'Logbuch',
      contents: 'Inhalte',
      dossier: 'Vorgang',
      dates: 'Datum',
      destinationCountries: 'Endbestimmungsländer',
      requestType: 'Antragsart',
      foreignBusiness: 'Auslandsgeschäfte',
      requestDetails: 'Antragsdetails',
      migration: 'Migration',
      allParties: 'Alle Beteiligte',
      transportation: 'Beförderung',
      processingDetails: 'Bearbeitungsdetails',
      status: 'Status',
      resubmission: 'Wiedervorlage',
      closure: 'Abschlussart',
      resubmissionDueDate: 'Frist Wiedervorlage',
      internalDetails: 'Bearbeitungsdetails',
      statusSection: 'Status',
      fileNumber: 'Aktenzeichen',
      assignment: 'Federführung',
      voting: 'Votum',
      decision: 'Entscheidung',
      approval: 'Genehmigung',
      collateralClauses: 'Nebenbestimmungen, Auflagen, Hinweise',
      completionChanges: 'Änderungsbescheide',
      general: 'Allgemein',
      feeCategory: 'Auswahl Gebührentatbestände',
      feeExemption: 'Tatbestände der Gebührenbefreiung',
      newRequest: 'Neuantrag',
      calculation: 'Berechnung',
      differingFeesSingleCase: 'Abweichende Gebührenerhebung im Einzelfall',
      feeExemptionFacts: 'Tatbestände der Gebührenbefreiung',
      discount: 'Ermäßigung',
      requestWithMultipleFees:
        'Vorgang mit mehreren gebührenfähigen Leistungen',
      longProcessingTime: 'Lange Bearbeitungszeit',
      otherReasons: 'Sonstige Gründe',
      identifiers: 'Vorgangskennung',
    },
    goodsTable: {
      description: 'Warenbezeichnung',
      quantity: 'Anzahl',
      unit: 'Einheit',
      worth: 'Warenwert',
      currency: 'Währung',
      catalog: 'Ware lt. Katalog',
      listPosition: 'Listenposition',
      empty: 'Keine Waren vorhanden',
      showMore: 'Alle {0} Warenpositionen anzeigen',
      showLess: 'Weniger anzeigen',
    },
    goodItems: {
      kwlGoods:
        'KWL-Nr. und Bezeichnung | AL-Nr. und Bezeichnung | Spezifikation',
      description: 'Warenbezeichnung',
      quantity: 'Anzahl',
      unit: 'Einheit',
      worth: 'Warenwert',
      totalWorth: 'Gesamtwert aller Einzelwerte',
      currency: 'Währung',
      catalog: 'Ware lt. Katalog',
      kwlNumber: 'KWL-Nummer',
      isComponentsAccessories: 'Bestandteile/Zubehör',
    },
    logbook: {
      empty: 'Keine Logbucheinträge vorhanden',
      date: 'Datum',
      message: 'Meldung',
      signature: 'Wird beim Speichern als Signatur angehängt:',
    },
    contents: {
      new: 'Neu',
      upload: 'Hochladen',
      name: 'Name',
    },
    placeholders: {
      notAvailable: '–',
    },
    party: {
      runningNumber: 'Laufende Nummer',
      role: 'Rolle',
      companyName: 'Firmenname',
      street: 'Straße',
      zipCode: 'Postleitzahl',
      city: 'Ort',
      addressAddendum: 'Adresszusatz',
      controlNumber: 'K-Nummer',
      eoriNumber: 'EORI-Nr.',
      country: 'Land',
      companyInCatalog: 'Firma lt. Katalog',
      addendum: 'Zusatz',
    },
    transportation: {
      fromTo: (a?: string | null, b?: string | null, routes: string[] = []) =>
        `Von ${a ?? dossierStrings.detail.transportation.unknown} nach ${b ?? dossierStrings.detail.transportation.unknown} (${routes.join(', ')})`,
      name: 'Name',
      city: 'Ort',
      companyInCatalog: 'Firma lt. Katalog',
      transportationFrom: 'Beförderung von',
      transportationTo: 'Beförderung nach',
      route: 'Transportweg',
      frequency: 'Beförderungshäufigkeit',
      unknown: 'Unbekannt',
    },
    votes: {
      date: 'Datum',
      voter: 'Votierender',
      vote: 'Votum',
      addendum: 'Zusatz',
    },
    collateralClauses: {
      collateralClause: 'Nebenbestimmung',
      content: 'Inhalt',
    },
    calculation: {
      totalOfAllGoods: 'Gesamtwert aller Kriegswaffen',
      intermediateSum: 'Zwischensumme der Gebühren',
      additionalFees: 'Zusatzgebühr',
      calculatedTotalFee: 'Berechnete Gesamtgebühr',
      twoPercentValue: '2% des Warenwertes',
      finalFee: 'Finale Gebühr für Antragsteller',
    },
  },
  actions: {
    editData: 'Daten bearbeiten',
    clone: 'Vorgang duplizieren',
  },
  tabs: {
    logbook: 'Logbuch',
    general: 'Allgemein',
    request: 'Antrag',
    parties: 'Beteiligte',
    transportation: 'Beförderung',
    goods: 'Waren',
    internal: 'Intern',
    approval: 'Genehmigung',
    fees: 'Gebühren',
  },
  similarDossiers: {
    listPositions: 'Listenpositionen',
  },
  newDossierTitle: 'Neuer Einzelvorgang',
  commands: {
    groups: {
      manage: 'Verwalten',
      notifications: 'Benachrichtigungen',
      dossierManagement: 'Vorgangsverwaltung',
      export: 'Export',
    },
    resubmit: 'Vorgang wiedervorlegen',
    forward: 'Vorgang weiterleiten',
    complete: 'Vorgang abschließen',
    archive: 'Vorgang verakten',
    resume: 'Vorgang wiederaufnehmen',
    delete: 'Vorgang löschen',
    exportDossierList: 'Liste exportieren',
    exportDossier: 'Vorgang exportieren',
    importDossier: 'Vorgang importieren',
    dossierRelatedMessage: 'Vorgangsbezogene Nachricht',
    assign: 'Vorgang zuordnen',
    takeLeadership: 'Federführung übernehmen',
    transferLeadership: 'Federführung übertragen',
    sendMessage: 'Nachricht versenden',
    taskToLeader: 'Aufgabe an Federführer',
    initiateInformalParticipation: 'Informelle Beteiligung einleiten',
    dossierDocuments: 'Vorgangsdokumente',
    generateApproval: 'KWKG-Genehmigung erstellen',
    contractDocuments: 'Vertragsdokumente',
    generateKwkgApproval: 'KWKG-Genehmigung generieren',
    generateFeeBill: 'Gebührenbescheid generieren',
    generateFeeExemption: 'Gebührenbefreiung generieren',
    sendReceiptConfirmation: 'Eingangsbestätigung versenden',
    assignNextAvailableTan: 'Nächstes freies Kassenzeichen zuordnen',
  },
};
